import { type CSSProperties } from "react"
import { useDocumentTitle } from "~/common/use-document-title"
import { useScrollToLocationHash } from "~/common/use-scroll-to-location-hash"
import { BoldFooter } from "~/components/marketing-bold/bold-footer"
import { BoldHero } from "~/components/marketing-bold/bold-hero"
import { BoldJoin } from "~/components/marketing-bold/bold-join"
import { BoldNav } from "~/components/marketing-bold/bold-nav"
import { BoldProblem } from "~/components/marketing-bold/bold-problem"
import { BoldStatBand } from "~/components/marketing-bold/bold-stat-band"
import { BoldWeekboard } from "~/components/marketing-bold/bold-weekboard"
import { FounderNote } from "~/components/marketing/founder-note"
import { ThemePreviewSwitcher } from "~/components/marketing/theme-preview-switcher"

const fontVars = {
  "--font-family-heading": '"Cormorant Garamond Variable", "Cormorant Garamond", serif',
  "--font-family-body": '"Inter Variable", "Inter", sans-serif',
} as CSSProperties

export function ComingSoonPage() {
  useDocumentTitle("More Connected", "")
  useScrollToLocationHash()

  return (
    <div
      id="top"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--color-background)",
        color: "var(--color-text-primary)",
        fontFamily: "var(--font-family-body)",
        ...fontVars,
      }}
    >
      <BoldNav mode="coming-soon" />
      <main data-testid="marketing-coming-soon" style={{ flex: 1 }}>
        <BoldHero mode="coming-soon" />
        <BoldStatBand />
        <BoldProblem />
        <BoldWeekboard />
        <BoldJoin variant="ember" mode="coming-soon" />
        <FounderNote />
      </main>
      <BoldFooter mode="coming-soon" />
      <ThemePreviewSwitcher />
    </div>
  )
}
